<template>
  <div class="builder__step" :class="{ 'builder__step--expanded': isExpanded }" v-if="isVisible" v-show="option.display_type !== 'hidden'">

    <div class="builder__step-heading-and-tip" v-if="option.is_embroidery_grouped != '1'">
      <div class="builder__step-heading">
        <h3 class="builder__step-heading-main">
          <button type="button" @click="toggleOptionVisibility">{{ option.display_title ? option.display_title : option.title }}</button>
        </h3>
      </div>
      <div class="builder__step-tip" v-if="has_tip">
        <div class="builder__step-tip-trigger">
          <button @click="showTipPopup">Tip</button>
        </div>
        <div :id="tipPopupDomId" class="mfp-hide builder__step-tip-content" v-html="option.tip_text"></div>
      </div>
    </div>

    <div class="builder__step-content">

      <builder-option-embroidery v-if="option.display_type == 'embroidery'" :option="option" @input="$emit('input', option.id, $event)" @toggle-embroidery="isEmbroideryGroupVisible = $event"></builder-option-embroidery>

      <div class="builder__step-options" :class="{ 'builder__step-options--expanded': isEmbroideryGroupVisible }">

        <div v-if="option.display_type != 'embroidery'" class="builder__step-option">
          <component :is="componentNameForOptionType(option.display_type)" :option="option" @input="$emit('input', option.id, $event)"></component>
        </div>

        <div v-for="subOption in option.embroidery_grouped_options" class="builder__step-option">
          <!--component :is="componentNameForOptionType(subOption.display_type)" :option="subOption" @input="$emit('input', subOption.id, $event)"></component-->
          <builder-option
           :option="subOption"
           @input="propagateInput"
          ></builder-option>
        </div>

      </div><!-- .builder__step-options -->
    </div><!-- .builder__step-content -->

  </div><!-- .builder__step -->
</template>

<script>
  export default {
    components: {
      'builder-option-color': require('./option-types/Color.vue'),
      'builder-option-embroidery': require('./option-types/Embroidery.vue'),
      'builder-option-error': require('./option-types/Error.vue'),
      'builder-option-font': require('./option-types/Font.vue'),
      'builder-option-hidden': require('./option-types/Hidden.vue'),
      'builder-option-radios': require('./option-types/Radios.vue'),
      'builder-option-select': require('./option-types/Select.vue'),
      'builder-option-swatch': require('./option-types/Swatch.vue'),
      'builder-option-textarea': require('./option-types/Textarea.vue'),
      'builder-option-textbox': require('./option-types/Textbox.vue'),
    },

    name: 'builder-option',

    props: ['option', 'isExpanded'],

    data() {
      return {
        has_tip: this.option.tip_text && this.option.tip_text.length > 0,
        isEmbroideryGroupVisible: (this.option.display_type != 'embroidery' || this.option.selected_value),
        tipPopupDomId: 'tip-popup-' + this.option.id,
      }
    },

    computed: {
      isVisible() {
        return this.$root.$children[0].isOptionAvailable(this.option.id)
      },
    },

    methods: {
      componentNameForOptionType(type) {
        const names = {
          'color':      'builder-option-color',
          'embroidery': 'builder-option-embroidery',
          'font':       'builder-option-font',
          'hidden':     'builder-option-hidden',
          'radios':     'builder-option-radios',
          'select':     'builder-option-select',
          'swatch':     'builder-option-swatch',
          'textarea':   'builder-option-textarea',
          'textbox':    'builder-option-textbox',
        }

        return (type in names ? names[type] : 'builder-option-error')
      },

      propagateInput(optionId, choiceIdOrText) {
        this.$emit('input', optionId, choiceIdOrText)
      },

      toggleOptionVisibility() {
        if (this.isExpanded) {
          this.$emit('collapse-option')
        } else {
          this.$emit('expand-option', this.option.id)
        }
      },

      showTipPopup(event) {
        if ($('#' + this.tipPopupDomId).length) {
          event.preventDefault()
          $.magnificPopup.open({
            items: {
                src: '#' + this.tipPopupDomId,
              },
            type: 'inline',
            prependTo: '.js-the-page',
          })
        }
      }

    },
  }

</script>



// WEBPACK FOOTER //
// Option.vue?4be88e5b